import {Form} from 'antd';
import React, {useEffect, useState} from 'react';

import {detectAutoDetect} from '../../../../constants/Common';
import {APITypeEnum} from '../../../../services/interface/tableAPIType';
import businessTravelAPI from '../../../../services/modules/IP/businessTravelAPI';
import frequencyJSON from '../../../../services/modules/JSON/frequency';
import modeOfTransportTravJSON from '../../../../services/modules/JSON/modeOfTransportByTravel';
import BusinessForm from '../../../Forms/BusinessForm';
import Loader from '../../../Loader/Loader';
import {IComponentProps} from '../../Common/perquisiteMaster';

const BusinessTravelTicketsBills: React.FC<IComponentProps> = ({
  record,
  caForm,
  onFinishFailed,
  onValuesChange,
  onSubmit
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const initialValues = {
    facility: record?.facility,
    year: record?.year
  };

  useEffect(() => {
    Promise.all([
      record?.referenceRecordId &&
        businessTravelAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
      modeOfTransportTravJSON(),
      frequencyJSON()
    ])
      .then(([responseData]) => {
        if (responseData?.data?.isDeleted === false) {
          caForm.setFieldsValue(responseData?.data);
          onValuesChange(true);
        } else {
          const fData: any = record?.fields ?? undefined;
          const customFromData: any = {
            _id: '',
            facility: record?.facility,
            year: record?.year,
            firstName: fData?.firstName?.replace(/,/g, ''),
            lastName: fData?.lastName?.replace(/,/g, ''),
            email: fData?.email,
            mobile: fData?.mobile,
            mode: fData?.mode,
            travelFrom: fData?.travelFrom,
            travelTo: fData?.travelTo,
            cost: fData?.cost,
            status: 'ready_for_review',
            comment: '',
            dataSource: 'manual'
          };

          caForm.setFieldsValue(customFromData);
        }
      })
      .catch(() => {
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });

    return () => {
      onValuesChange(true);
    };
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <Form
      form={caForm}
      onFinish={onSubmit}
      onFinishFailed={() => {
        onFinishFailed();
      }}
      onValuesChange={() => {
        onValuesChange(false);
      }}
      initialValues={initialValues}
      autoComplete={detectAutoDetect()}
      layout="vertical"
      className="drawerForm"
    >
      <BusinessForm
        formSelectedCountry={undefined}
        setFormSelectedCountry={() => {}}
        defaultDisplayStep={true}
      />
    </Form>
  );
};

export default BusinessTravelTicketsBills;
